import {CALL_USER as SOCKET_CALL_USER, 
        CLOSE_CALL as SOCKET_CLOSE_CALL} from '../../events/DashboardToServer'
import {CALL_ACCEPTED as SOCKET_CALL_ACCEPTED} from '../../events/ClientToServer'
import {REFUSE_CALL as SOCKET_CALL_REFUSE} from '../../events/ClientToServer'

export const CALL_USER = 'CALL_USER'
export const USER_CALLED = 'USER_CALLED'
export const CALL_ACCEPTED = 'CALL_ACCEPTED'
export const CALL_CONFIRMED = 'CALL_CONFIRMED'
export const CALL_CLOSED = 'CALL_CLOSED'
export const CLOSE_CALL = 'CLOSE_CALL'
export const CALL_REFUSED = 'CALL_REFUSED'
export const REFUSE_CALL = 'REFUSE_CALL'


/*
    NO_CALL: 0,
    CALL_INCOMING: 1
    CALL_ACCEPTED: 2,
    CALL_REFUSED: 3,
    CALL_CLOSING: 4
*/

export const videocall = (state = 0, action) => {
    switch (action.type) {
    
        case CALL_CONFIRMED:
            return action.result

        case REFUSE_CALL:
            return 0

        case CALL_REFUSED:
            return 0

        case CALL_ACCEPTED:
            return 2

        case USER_CALLED:
            return action.result

        case CALL_CLOSED:
            return 0

        default:
            return state
    }
}

export const callUser = (socket, {user_id}) => {
    socket.emit(SOCKET_CALL_USER, {user_id})
    return { type: CALL_USER, user_id}
}

export const userCalled = ({user_id}) => {
    return {     type: USER_CALLED, user_id:user_id, result:1}
}

export const callAccepted = (socket, camera, microphone, user_id,host ) => {
    socket.emit(SOCKET_CALL_ACCEPTED, {camera:camera, microphone:microphone, user_id:user_id, host:host, result:2})
    return { type: CALL_ACCEPTED,  camera:camera, microphone:microphone,  user_id:user_id, host:host, result:2}
}

export const refuseCall = (socket, user_id) => {
    socket.emit(SOCKET_CALL_REFUSE, {user_id:user_id, result:3})
    return { type: REFUSE_CALL, user_id:user_id, result:3}
}

export const callRefused = ({user_id, result}) => {
    return { type: CALL_REFUSED, user_id, result}
}

export const callConfirmed = ({user_id, result}) => {
    return { type: CALL_CONFIRMED,  user_id, result}
}

export const closeCall = (socket, user_id) => {
    socket.emit(SOCKET_CLOSE_CALL, {user_id:user_id, result: 4})
    return { type: CLOSE_CALL, user_id:user_id, result:4}
}

export const callClosed = (user_id, result) => {
    return { type: CALL_CLOSED, user_id:user_id, result:0}
}


// WEBPACK FOOTER //
// ./src/reducers/videocall/index.js